import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, withRouter } from 'react-router'
import PropTypes from 'prop-types'
import CompanyProfileContainer from '../CompanyProfileContainer/CompanyProfileContainer'
import AddContractContainer from '../AddContract/AddContractContainer'
import CompaniesActions from '../../Data/Redux/CompaniesRedux'

class CompanyContainer extends Component {
  componentWillMount() {
    this.props.getCompanyProfile()
  }

  componentWillUnmount() {
    this.props.resetCompanyProfile()
  }

  render() {
    const { match } = this.props

    return (
      <div>
        <Route exact path={`${match.path}`} component={CompanyProfileContainer} />
        <Route path={`${match.path}/add-contract`} component={AddContractContainer} />
      </div>
    )
  }
}

CompanyContainer.propTypes = {
  /** Data attributes from the current URI */
  match: PropTypes.object.isRequired,
  /** Fetch the current Company's profile data from the API */
  getCompanyProfile: PropTypes.func.isRequired,
  /** Remove the Company's profile data from the redux store */
  resetCompanyProfile: PropTypes.func.isRequired,
}

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch, { match }) => ({
  getCompanyProfile: () => dispatch(CompaniesActions.getOneRequest(match.params.id)),
  resetCompanyProfile: () => dispatch(CompaniesActions.getOneReset()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyContainer))



// WEBPACK FOOTER //
// ./src/Containers/CompanyContainer/CompanyContainer.jsx